import { createContext, useContext, useState, useMemo, ReactNode, Dispatch, SetStateAction } from 'react';
import { Path } from 'slate';

export interface TagNavContextValue {
  selectedFootnoteId: string | null;
  selectedExcludePath: Path | null;
  setSelectedFootnoteId: Dispatch<SetStateAction<string | null>>;
  setSelectedExcludePath: Dispatch<SetStateAction<Path | null>>;
}

export const TagNavContext = createContext<TagNavContextValue>({} as TagNavContextValue);

export const TagNavProvider = ({ children }: { children: ReactNode }) => {
  const [selectedFootnoteId, setSelectedFootnoteId] = useState<string | null>(null);
  const [selectedExcludePath, setSelectedExcludePath] = useState<Path | null>(null);

  const value = useMemo<TagNavContextValue>(
    () => ({ selectedFootnoteId, selectedExcludePath, setSelectedFootnoteId, setSelectedExcludePath }),
    [selectedFootnoteId, selectedExcludePath]
  );

  return <TagNavContext.Provider value={value}>{children}</TagNavContext.Provider>;
};

export const useTagNav = () => useContext(TagNavContext);
